module.exports = __webpack_public_path__ + "static/img/record.ef892711.png";